import { PublicRegistryCsvExport, useDownloadPublicRegistryCsv } from "@/hooks/registry/useDownloadPublicRegistryCsv";
import { BsArrowDownCircle } from "react-icons/bs";

type RegistryCsvDownloadButtonProps = {
	exportRequest: PublicRegistryCsvExport;
	label: string;
};

const RegistryCsvDownloadButton = ({ exportRequest, label }: RegistryCsvDownloadButtonProps) => {
	const { mutate, isLoading } = useDownloadPublicRegistryCsv();

	return (
		<button
			type="button"
			onClick={() => mutate(exportRequest)}
			disabled={isLoading}
			aria-label={label}
			aria-busy={isLoading}
			className="flex items-center gap-2 rounded-full border border-secondary bg-white px-5 py-2 text-sm font-medium text-secondary transition-colors hover:bg-secondary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary disabled:cursor-not-allowed disabled:opacity-60"
		>
			{isLoading ? "Downloading…" : label}
			<BsArrowDownCircle className="h-4 w-4" aria-hidden />
		</button>
	);
};

export default RegistryCsvDownloadButton;
